@if (layout.sidebarOpen()) {
  <div class="sidebar-backdrop" (click)="layout.closeSidebar()"></div>
}
<nav class="sidebar" [class.open]="layout.sidebarOpen()" [class.collapsed]="layout.sidebarCollapsed()">
  <div class="sidebar-header">
    <img class="app-logo" src="/branding/app-logo.png" [alt]="'shared.brand' | translate" />
  </div>

  @for (item of navItems(); track item.path) {
    <a [routerLink]="item.path" routerLinkActive="active" class="nav-item" (click)="layout.closeSidebar()">
      <app-icon [name]="item.icon" [size]="18" />
      <span class="label">{{ item.labelKey | translate }}</span>
    </a>
  }

  <button type="button" class="collapse-toggle" (click)="layout.toggleSidebarCollapsed()">
    <app-icon [name]="layout.sidebarCollapsed() ? 'chevron-right' : 'chevron-left'" [size]="14" class="flip-rtl" />
    <span class="label">{{ (layout.sidebarCollapsed() ? 'shared.nav.expandMenu' : 'shared.nav.collapseMenu') | translate }}</span>
  </button>
</nav>
